import isEqual from "lodash/isEqual";

import type { GetMeQuery } from "../../api/generated/graphql";

import type { WaterlyAppStateCreator } from "./waterlyAppStateCreator.type";

type LoggedInUserState = {
  loggedInUser: GetMeQuery["me"] | null;
};

type LoggedInUserActions = {
  setLoggedInUser: (loggedInUser: GetMeQuery["me"] | null) => void;
};

const initialState: LoggedInUserState = {
  loggedInUser: null,
};

export const createLoggedInUserSlice: WaterlyAppStateCreator<LoggedInUserActions, LoggedInUserState> = (
  set,
) => ({
  ...initialState,

  setLoggedInUser: (loggedInUser: GetMeQuery["me"] | null) =>
    set(
      (state) => (isEqual(state.loggedInUser, loggedInUser) ? state : { loggedInUser }),
      undefined,
      "apolloClient:setLoggedInUser",
    ),
});
